const imageConfig = {
  dashboard: { banner: 'dashboard-banner' },

  contest: {
    banner1: 'contest-banner-1',
    banner2: 'contest-banner-2',
    'upcoming-banner': 'upcoming-contest-banner',
    'ranking-banner': 'contest-ranking-banner'
  },

  forgetPassword: {
    'pc-logo': 'forgot-password-pc-logo',
    'mobile-log': 'forgot-password-mobile-logo'
  },

  confirmPassword: {
    'pc-logo': 'confirm-password-pc-logo',
    'mobile-logo': 'confirm-pasword-mobile-logo'
  },

  course: {
    'video-navbar-logo': 'course-video-nabar-logo',
    'wishlist-banner': 'course-wishlist-banner'
  },

  sideBar: { logo: 'sidebar-logo' },

  navbar: { logo: 'navbar-logo' }
};

export default imageConfig;
